module.exports = __webpack_public_path__ + "icons_05.f356f48b.svg";